import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  // During SSR, allow rendering — the real check happens client-side after hydration
  if (isPlatformServer(platformId) && !authService.isInitialized()) {
    return true;
  }

  // Already authenticated (user signal has a value)
  if (authService.isAuthenticated()) {
    return true;
  }

  // Session check already done but user is not authenticated
  if (authService.isInitialized()) {
    return router.createUrlTree(['/login']);
  }

  // First load: check session via /me, then decide
  return authService.checkSession().pipe(
    map((_user) => authService.isAuthenticated() ? true : router.createUrlTree(['/login']))
  );
};
